export * from './updateActivityScoring.js'
